import React from 'react';
import PropTypes from 'prop-types';
import {connect} from 'react-redux';
import {actions, selectors} from '../Redux/index';
import {i18n, formatTableDataForExport, formatDate} from '../Utility/Format';
import SpotTable from '../Components/Tables/SpotTable';
import LastUpdateMessage from '../Components/Widgets/LastUpdateMessage';
import TableExport from '../Components/Widgets/TableExport';
import {ValueDateCalendarToggle} from './Application/ValueDateCalendar';
import StageActions from '../Components/Widgets/StageActions';

/**
 * The Spot view container. One of the top-level views of the application.
 */
class Spot extends React.Component {

    componentDidMount() {
        this.props.getSpotData();
    }

    onDownload(type) {
        return () => this.props.downloadFile(type, formatTableDataForExport({
            key: "spot",
            title: "Spot",
            data: this.props.table,
            lang: this.props.locale
        }));
    }

    render() {
        const onClick = {
            pdf: this.onDownload('pdf'),
            xlsx: this.onDownload('xlsx'),
            csv: this.onDownload('csv')
        };

        const {table, locale} = this.props;

        const isEmpty = !table.data || table.data.length === 0;

        return (
            <div className="spot">
                {
                    isEmpty ? <center>{i18n(table.data ? 'dbm.table.emptyData' : 'dbm.table.loadingData')}</center> : (
                        <div>
                            <SpotTable rows={table.data ? table.data : []} locale={locale}/>
                            <LastUpdateMessage date={table.lastUpdate}/>
                        
                        </div>
                    )
                }

                <StageActions
                    left={
                        <TableExport
                            label={i18n('dbm.stage.nav.spot')}
                            onClickPDF={onClick.pdf}
                            onClickCSV={onClick.csv}
                            onClickXLSX={onClick.xlsx}
                            aria-label={i18n('dbm.stage.nav.spot')}
                        />
                    }
                    right={
                        <ValueDateCalendarToggle onTogglePanel={this.props.onValuedateClick} />
                    }
                /> 
            </div>
        );


    }
}
;

const mapDispatchToProps = (dispatch) => {
    return {
        downloadFile: (type, data) => {
            dispatch(actions.Data.Download.requestDownloadFile({type: type, data: {body: JSON.stringify(data)}}))
        },
        getSpotData: () => {
            dispatch(actions.Data.Reload.sagaReloadData());
        },
        onCloseOptionsPanel: () => {
            dispatch(actions.UI.OptionsMenu.toggleOptionsForm());
            dispatch(actions.UI.OptionsMenu.toggleOptionsMenu());
        },
        onValuedateClick: () => {
            dispatch(actions.UI.OptionsMenu.toggleValueDateCalendar());
            dispatch(actions.UI.OptionsMenu.toggleOptionsMenu());
        }
    }
};

const mapStateToProps = (state) => {
    return {
        table: selectors.Data.Spot.getData(state),
        isValueDateVisible: selectors.UI.OptionsMenu.isValueDateVisible(state),
        locale: selectors.UI.Locale.getLocale(state),
        currencies: selectors.Data.Currency.getCurrencies(state)
    };
};

Spot.propTypes = {
    table: PropTypes.object.isRequired,
    locale: PropTypes.string
};

export default connect(mapStateToProps, mapDispatchToProps)(Spot);